import {Button, Table, message} from "antd";
import {Link} from "react-router-dom";

export const ApplyLists = () => {
    const columns = [
        {
            title: 'Công việc',
            dataIndex: 'job',
            key: 'job',
        },
        {
            title: 'Hạn nộp',
            dataIndex: 'deadline',
            key: 'deadline',
        },
        {
            title: 'Hồ sơ',
            dataIndex: 'application',
            key: 'application',
        },
        {
            title: 'Trạng thái',
            key: 'status',
            dataIndex: 'status',
        },
    ]
    const data = [
        {
            key: '1',
            job: 'Thợ sửa ống nước',
            deadline: '30/2/2025',
            application: 'CV 1',
            status: 'Đang xử lý',
        },
        {
            key: '2',
            job: 'Thợ hàn ống sắt',
            deadline: '30/2/2025',
            application: 'Cv 2',
            status: 'Đã duyệt',
        },
        {
            key: '3',
            job: 'Công nhân',
            deadline: '30/1/2025',
            application: 'CV 3',
            status: 'Hết hạn',
        },
    ]
    const handleReset = () => {
        message.success('Làm mới thành công!');
    };

    const handleExtend = () => {
        message.success('Gia hạn thành công!');
    };

    const handleDelete = () => {
        message.success('Xóa thành công!');
    };
    return (
        <>
            <div className={"flex flex-wrap gap-4 w-full px-4"}>
                <div className={"flex flex-row"}>
                    <Button
                        className={"bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"}
                        onClick={handleReset}
                    >
                        Làm mới
                    </Button>
                    <Button
                        className={"bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"}
                        onClick={handleExtend}
                    >
                        Gia hạn
                    </Button>
                    <Button
                        className={"bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"}
                        onClick={handleDelete}
                    >
                        Xóa
                    </Button>
                </div>
                <Table
                    className={"w-full"}
                    columns={columns}
                    dataSource={data}
                    bordered
                />
            </div>
        </>
    )
}